import styled from 'styled-components'

export const NotificationListSection = styled.div`
	padding: 10px;
`
export const NotificationListItemSection = styled.div`
	display: flex;
	flex-direction: row;
	height: 90px;
	justify-content: space-between;
	@media only screen and (max-width: 600px) {
		height: 120px;
	}
`
export const NotificationItemLeft = styled.div`
	width: 20%;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	margin-top: 10px;
	padding-left: 10px;
`
export const NotificationItemBody = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	width: 80%;
	justify-content: space-around;
	border-bottom: 1px solid ${p => p.theme.COLORS.borderColor};
`
